// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles-module--footer--2j8xa","social":"styles-module--social--1e5M2"};